import { gql } from "@apollo/client";

export const GENERATE_LINK = gql`
  query GenerateLink($url: String!) {
    linkQuery {
      generateDynamicLinkFromUrl(url: $url)
    }
  }
`;
